<div>
  <div class="login-form">
    <div style="text-align: center;">
      <div style="text-align: center; margin-bottom: 1em;">
        <img src="assets/images/folio-logo.png" style="width: 7rem;" />
      </div>
      <mat-card class="login-form-card" *ngIf="!isSuccess" fxLayout="column">
        <mat-card-title>{{labelHeading}}</mat-card-title>
        <br />
        <form>
          <mat-form-field appearance="outline">
            <mat-label>Username</mat-label>
            <input matInput [formControl]="nameFormControl">
            <mat-error *ngIf="nameFormControl.hasError('email') && !nameFormControl.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="nameFormControl.hasError('required')">
              Username is
              <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput [formControl]="passwordFormControl" [type]="hidePassword ? 'password': 'text'" autocomplete="off">
            <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' :
              'visibility_off'}}
            </mat-icon>
            <mat-error *ngIf="passwordFormControl.hasError('email') && !passwordFormControl.hasError('required')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="passwordFormControl.hasError('required')">
              Password is
              <strong>required</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input matInput [formControl]="newPasswordFormControl" [type]="hideNewPassword ? 'password': 'text'"
              autocomplete="off">
            <mat-icon matSuffix (click)="hideNewPassword = !hideNewPassword">{{hideNewPassword ? 'visibility' :
              'visibility_off'}}
            </mat-icon>
            <mat-error *ngIf="newPasswordFormControl.hasError('required')">
              New Password is
              <strong>required</strong>
            </mat-error>
          </mat-form-field>
        </form>
        <mat-error *ngIf="showErrorStatus">
          {{errorMessage}}
        </mat-error>
        <button color="accent" style="width: 10em; max-width: 15em; text-align: center; margin: auto !important; border-radius: 50px;"
          type="submit" mat-raised-button class="save-button" (click)="changePassword()">
          {{labelChangePasswordButton}}
        </button>
      </mat-card>

      <mat-card class="login-form-card" *ngIf="isSuccess" fxLayout="column">
        <mat-card-title>{{labelSuccess}}</mat-card-title>
        <mat-card-content>
          <mat-icon style="text-align: center; margin-left: -0.75em; font-size: 8em; color: green;">check_circle_outline</mat-icon>
        </mat-card-content>
        <mat-card-footer>
          <span>
            {{labelChangedPasswordSuccessfully}}
          </span>
        </mat-card-footer>
      </mat-card>

    </div>
    <!-- login form div -->
    <div style="text-align: center;margin-top: .5rem;">
      <span style="color: black; font-size: small;">© 2019 FocalCXM Pvt. Ltd. All Rights Reserved.</span>
    </div>
  </div>
</div>